import { createRouter, createWebHashHistory } from 'vue-router'
import NotFound from '../views/NotFound.vue'
import PreHome from '../views/PreHome.vue'
import Home from '../views/Home.vue'
import Video from '../views/Video.vue'
import LegalBases from '../views/LegalBases.vue'
import Policy from '../views/Policy.vue'
import CookiesPolicy from '../views/CookiesPolicy.vue'
import LegalAdvise from '../views/LegalAdvise.vue'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/:alias_url/:preview?',
    name: 'Prehome',
    component: PreHome
  },
  {
    path: '/:alias_url/:preview?/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/:alias_url/:preview?/video/:video_id',
    name: 'Video',
    component: Video
  },
  {
    path: '/:alias_url/:preview?/legal_bases',
    name: 'LegalBases',
    component: LegalBases
  },
  {
    path: '/:alias_url/:preview?/policy',
    name: 'Policy',
    component: Policy
  },
  {
    path: '/:alias_url/:preview?/cookies_policy',
    name: 'CookiesPolicy',
    component: CookiesPolicy
  },
  {
    path: '/:alias_url/:preview?/legal_advise',
    name: 'LegalAdvise',
    component: LegalAdvise
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
